<template>
  <el-card>
    <div
        slot="header"
        class="clearfix">
      <span class="header-item">{{ $t('customer_transfers.title') }}</span>
      <span :class="{'ring-card__header-buttons': true, 'disable-html': loading }">
        <RefreshButton @click.native="getCustomerTransfers()" />
      </span>
    </div>
    <div
        v-loading="loading"
        class="card-content">
      <el-table
          :data="customer_transfers"
          class="device-transfers-table"
          style="width: 100%"
          max-height="500">
        <el-table-column
            label="Actions">
          <template slot-scope="scope">
            <div v-if="scope.row.id && scope.row.status.toLowerCase() == 'in_progress' ">
              <el-button
                  slot="reference"
                  type="text"
                  @click="showDialog(scope.row)">
                <el-tooltip
                    class="item"
                    effect="dark"
                    :content="tooltip"
                    placement="top-start">
                  <i
                      class="el-icon-delete"></i>
                </el-tooltip>
              </el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="Doorbot id">
          <template slot-scope="scope">
            {{ scope.row.doorbot_id }}
          </template>
        </el-table-column>
        <el-table-column label="Mac Address">
          <template slot-scope="scope">
            {{ scope.row.mac_address }}
          </template>
        </el-table-column>
        <el-table-column label="Product">
          <template slot-scope="scope">
            {{ findProduct(scope.row).description | capitalize }}
          </template>
        </el-table-column>
        <el-table-column label="Old Owner">
          <template slot-scope="scope">
            {{ scope.row.old_owner_id }}
          </template>
        </el-table-column>
        <el-table-column label="New Owner">
          <template slot-scope="scope">
            <span v-if="parseInt(scope.row.new_owner_id)>0 && scope.row.new_owner_id!=null">{{ scope.row.new_owner_id }}</span>
          </template>
        </el-table-column>
        <el-table-column label="Status">
          <template slot-scope="scope">
            {{ scope.row.status }}
          </template>
        </el-table-column>
        <el-table-column label="Reason">
          <template slot-scope="scope">
            {{ scope.row.reason }}
          </template>
        </el-table-column>
        <el-table-column label="Start Date">
          <template slot-scope="scope">
            {{ scope.row.start_date | moment('MM/DD/YYYY HH:mm Z') }}
          </template>
        </el-table-column>
        <el-table-column label="End Date">
          <template slot-scope="scope">
            {{ scope.row.end_date | moment('MM/DD/YYYY HH:mm Z') }}
          </template>
        </el-table-column>
      </el-table>


      <el-dialog
          :visible.sync="selectedRow.id !== undefined"
          title="Canceling device transfer"
          width="30%"
          :show-close="false"
          center>
        <p style="font-size: 16px; word-break: break-word; text-align: initial; color: #606266">
          This transfer will be canceled. Id: {{ selectedRow.id }}
        </p>
        <div style="text-align: right; margin: 0">
          <el-button
              size="mini"
              type="text"
              @click="hideDialog()">
            cancel
          </el-button>
          <el-button
              :loading="loading"
              type="primary"
              size="mini"
              @click="cancelTransfer(selectedRow.id)">
            confirm
          </el-button>
        </div>
      </el-dialog>
    </div>
  </el-card>
</template>

<script>
import { createNamespacedHelpers as h } from "vuex";
import RefreshButton from "@/containers/Customer/RefreshButton";
const { mapActions, mapGetters } = h("db/account");
const { mapGetters: sharedGetters } = h("shared");
export default {
  name: "CustomerTransfers",
  components: {
    RefreshButton,
  },
  data() {
    return {
      loading: false,
      selectedRow: {},
      tooltip: "Cancel device Transfer",
      error: {
        value: false,
        message: "Failed to load customer's device transfers",
      },
      customer_transfers: [],
    };
  },
  computed: {
    ...mapGetters(["customerId", "customer"]),
    ...sharedGetters(["products"]),
  },
  created() {
    this.getCustomerTransfers();
  },
  methods: {
    ...mapActions(["fetchCustomerTransfers", "cancelCustomerTransfer"]),
    findProduct(dh) {
      let p = this.products.find((p) => {
        return p.kind === dh.device_kind;
      });
      return p || { description: dh.device_kind };
    },
    showDialog(row) {
      this.selectedRow = row;
    },
    hideDialog() {
      this.selectedRow = {};
    },
    getCustomerTransfers() {
      this.loading = true;
      this.fetchCustomerTransfers({ customerId: this.customerId })
        .then((response) => {
          this.customer_transfers = response.device_transfers;
        })
        .catch((error) => {
          this.$notify({
            title: "Customer's device transfers",
            message: h(
              "i",
              { class: { "update-setting_error_msg": true } },
              "No transfers found"
            ),
            duration: 0,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    cancelTransfer(id) {
      this.cancelCustomerTransfer({ id: id })
        .then((response) => {
          this.getCustomerTransfers();
        })
        .catch((error) => {
          this.$notify({
            title: "Cancel customer's device transfers",
            message: h(
              "i",
              { class: { "update-setting_error_msg": true } },
              "No transfers found"
            ),
            duration: 0,
          });
        })
        .finally(() => {
          this.selectedRow = {};
        });
    },
  },
};
</script>

<style lang="scss">
.device-transfers-table {
  .user-email {
    display: block;
    color: $--color-curious-blue;
  }
}
</style>
